// extracted by mini-css-extract-plugin
export var notificationHost = "_le-0";